module.exports = __webpack_public_path__ + "static/media/prize1_without_num.05e7be40.svg";